<template>
  <b-col cols="12">
    <h3 class="mt-3 title-3">Turmas</h3>
    <b-row class="d-flex align-items-center">
      <b-col class="col-12 col-md-4 col-lg-3 col-xl-2 alinharValidacao">
        <input-select-search
          ref="cursoId"
          :label="$t(`ACADEMICO.CURSO`)"
          :options="opcoes.cursos"
          v-model="formCursos"
          :required="requerido"
          :loading="loadingCursos"
        />
      </b-col>

      <b-col class="col-12 col-md-4 col-lg-3 col-xl-2 alinharValidacao">
        <input-select-search
          ref="turmaId"
          :label="$t(`ACADEMICO.TURMA`)"
          :options="opcoes.turmas"
          v-model="formTurmas"
          :isDisabled="desabilitar.turma"
          :required="requerido"
        />
      </b-col>
      <b-col class="alinharValidacao ajuste-btn">
        <b-button variant="primary" @click="getTurmaId" :disabled="!formTurmas">Adicionar Turma</b-button>
        <b-button variant="success" @click="adicionarTodasTurmas" :disabled="!formCursos" class="ml-2">Adicionar Todas as Turmas</b-button>
      </b-col>
    </b-row>
    <tabela-turmas :items="form.turmas" @excluir="excluir" />
    <small class="text-muted aviso-turmas">
      As alterações nas turmas só serão gravadas ao clicar em Salvar.
    </small>
  </b-col>
</template>
<script>
import CursoService from '@/common/services/academico/curso.service';
import TurmaService from '@/common/services/academico/turma.service';

import TabelaTurmas from './TabelaTurmas.vue';
import VerificacaoPreenchimento from '@/components/mixins/verificacao-preenchimento';

import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

import { InputSelectSearch } from '@/components/inputs';
import helpers from '@/common/utils/helpers';

export default {
  mixins: [VerificacaoPreenchimento],
  components: {
    InputSelectSearch,
    TabelaTurmas,
  },
  props: {
    form: { type: Object, default: Object },
  },
  mounted() {
    this.getCursos();
  },
  watch: {
    formCursos: 'getTurmas',
  },
  data() {
    return {
      id: this.$route.params.id,
      formCursos: '',
      formTurmas: '',
      requerido: true,
      desabilitar: {
        turma: true,
      },
      opcoes: {
        cursos: [],
        turmas: [],
      },
      loadingCursos: false,
    };
  },
  methods: {
    getCursos() {
      this.loadingCursos = true;
      CursoService.listar()
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.cursos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.loadingCursos = false;
        });
    },

    getTurmas() {
      if (this.formCursos) {
        this.$store.dispatch(START_LOADING);
        TurmaService.buscarPorCursoId(this.formCursos)
          .then(({ data }) => {
            data = data.map((row) => ({
              ...data,
              text: row.descricao,
              value: row.id,
            }));
            this.opcoes.turmas = data;
            this.habilitarCampo('turma');
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },

    getTurmaId() {
      this.requerido = true;

      if (this.form.turmas.find(turma => turma.id == this.formTurmas)) {
        mensagem.warning('Atenção', 'A turma selecionada já existe na listagem.')
        return
      }

      if (!this.validarFormulario(this.$refs)) return;

      if (this.formTurmas) {
        this.$store.dispatch(START_LOADING);
        TurmaService.buscarPorId(this.formTurmas)
          .then(({ data }) => {
            this.adicionarTurma(data);
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      }
    },

    adicionarTodasTurmas() {
      if (!this.formCursos) {
        mensagem.warning('Atenção', 'Selecione um curso primeiro.')
        return;
      }

      if (!this.opcoes.turmas || this.opcoes.turmas.length === 0) {
        mensagem.warning('Atenção', 'Nenhuma turma encontrada para este curso.')
        return;
      }

      const turmasNovas = this.opcoes.turmas.filter(opcao =>
        !this.form.turmas.some(turma => turma.id === opcao.value)
      );

      if (turmasNovas.length === 0) {
        mensagem.warning('Atenção', 'Todas as turmas deste curso já estão na listagem.')
        return;
      }

      mensagem.confirmacao(
        'Confirmação',
        `Deseja adicionar ${turmasNovas.length} turma(s) do curso selecionado à listagem? As turmas só serão gravadas ao salvar o período letivo.`
      ).then((result) => {
        if (!result.value) return;

        this.$store.dispatch(START_LOADING);

        Promise.all(turmasNovas.map(turma => TurmaService.buscarPorId(turma.value)))
          .then((responses) => {
            this.form.turmas.push(...responses.map(response => response.data));
            this.limparCampo();
            mensagem.sucesso(
              this.$t('GERAL.SUCESSO'),
              `${responses.length} turma(s) adicionada(s) à listagem. Clique em Salvar para gravar.`
            );
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    adicionarTurma(data) {
      this.form.turmas.push(data);
      this.limparCampo();
    },

    limparCampo() {
      this.formCursos = null;
      this.formTurmas = null;
      this.opcoes.turmas = [];
      this.desabilitar.turma = true;
      this.requerido = false;
    },

    validarFormulario(refs) {
      return helpers.validarFormulario(refs);
    },

    habilitarCampo(key) {
      this.desabilitar[key] = false;
    },

    excluir(item) {
      mensagem
        .confirmacao(null, this.$t('Deseja remover turma ?'))
        .then((result) => {
          if (!result.value) return;

          const indice = this.form.turmas.findIndex(turma => turma.id === item.item.id);
          if (indice >= 0) this.form.turmas.splice(indice, 1);
        });
    },
  },
};
</script>
<style>
.ajuste-btn {
  margin-top: 28px;
}
.aviso-turmas {
  display: block;
  margin-top: 8px;
}
</style>
